import template from '@components/expertise/discovery/discovery.module.scss';
import { StartProjectBlock } from '@components/shared/blocks/start-project-block';
import { IPopUpSection } from '../../discovery.state';
import style from './index.module.scss';

interface IPopUpSectionProps {
  section: IPopUpSection;
}

const PopUpSectionComponent = ({ section }: IPopUpSectionProps) => {
  function scrollToBlock(blockId: string) {
    document.getElementById(blockId)?.scrollIntoView();
  }
  return (
    <StartProjectBlock
      title={section.title}
      buttonText={'Start a project'}
      showIntoView={() => scrollToBlock(`start-project-form`)}
    />
  );
};

export default PopUpSectionComponent;
